// extracted by mini-css-extract-plugin
export default {"modalOverlay":"KA-z","modalContent":"LA-z","header":"MA-z","close":"NA-z"};